let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bvL9U")).then(() => parcelRequire('3ncrE'));